import { Controller } from "@hotwired/stimulus";
import DataTable from "datatables.net-dt";
import language from "datatables.net-plugins/i18n/es-MX.mjs";
import "datatables.net-responsive-dt";
import "datatables.net-fixedheader-dt";
import { html } from "code-tag";
import { loading } from "@core/bs-loading-indicator";
import Swal from "sweetalert2";
const claseCambiarEstaActivo = "accion-cambiar-estaActivo";
const claseAdministrar = "accion-btn-administrar";
const claseEliminar = "accion-eliminar";
const dateTimeFormat = Intl.DateTimeFormat("es-CR", {
    hour12: true,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    timeZone: "UTC",
});
function renderizadorFecha(valorVacio = "Indefinido") {
    return (data, type, row, meta) => {
        if (type === "display" || type === "filter") {
            if (!data) {
                return valorVacio;
            }
            let parsedDate = Date.parse(data);
            if (Number.isNaN(parsedDate)) {
                return data;
            }
            let formattedDate = dateTimeFormat
                .format(parsedDate)
                .replace(". ", "")
                .replace(".", "");
            return formattedDate;
        }
        else if (type === "sort" && !data) {
            return new Date().toISOString();
        }
        return data;
    };
}
export default class default_1 extends Controller {
    get tabla() {
        if (this.element instanceof HTMLTableElement) {
            return this.element;
        }
        throw new Error("This controller's element is not an HTMLTableElement.");
    }
    connect() {
        const tabla = this.tabla;
        this.$dataTable = new DataTable(tabla, {
            retrieve: true,
            language: {
                ...language,
                searchPlaceholder: '"Enter" para buscar...',
            },
            columns: [
                { data: "id", title: "ID" },
                { data: "nombreUsuario", title: "Nombre Usuario" },
                { data: "nombreRepresentante", title: "Emisor" },
                { data: "email", title: "Correo Emisor" },
                {
                    data: "ambiente",
                    title: "Ambiente",
                    render: (ambiente, tipo, fila, meta) => {
                        if (tipo === "display" ||
                            tipo === "filter" ||
                            tipo === "sort") {
                            return ambiente === "api-prod"
                                ? "Producción"
                                : "Pruebas";
                        }
                        return ambiente;
                    },
                },
                {
                    data: "llaveCriptograficaExpiracion",
                    title: "Firma Expira",
                    render: renderizadorFecha(),
                },
                {
                    data: "licenciaExpiracion",
                    title: "Licencia Expira",
                    render: renderizadorFecha(),
                },
                {
                    data: "estaActiva",
                    title: "Estado",
                    render: (estaActivo, tipo, fila, meta) => {
                        if (tipo === "display") {
                            const checkboxId = `estaActivo_checkbox_${fila.id}`;
                            const rutaCambiarEstaActivo = this.rutaCambiarEstaActivoValue.replace(/__id__|__esta_activo__/g, (match) => {
                                if (match === "__id__") {
                                    return fila.id;
                                }
                                if (match === "__esta_activo__") {
                                    // queremos invertir el estado de la compania...
                                    return fila.estaActiva ? "0" : "1";
                                }
                                return match;
                            });
                            return html `
                                <label for="${checkboxId}">
                                    ${estaActivo ? "Activo" : "Inactivo"}
                                </label>
                                <div class="ib-switch-container">
                                    <input
                                        type="checkbox"
                                        id="${checkboxId}"
                                        class="ib-switch-input ${claseCambiarEstaActivo}"
                                        ${estaActivo ? "checked" : ""}
                                        value="${fila.id}"
                                        data-ruta-cambiar-esta-activo="${rutaCambiarEstaActivo}"
                                    />
                                    <label
                                        class="ib-switch-label"
                                        for="${checkboxId}"
                                    ></label>
                                </div>
                            `;
                        }
                        return estaActivo;
                    },
                },
                {
                    data: null,
                    title: "Modificar",
                    render: (datos, tipo, fila, meta) => {
                        if (tipo === "display") {
                            const rutaVerDetalles = this.rutaVerDetallesValue.replace(/__nombre_usuario__/g, datos.nombreUsuario);
                            return html `
                                <a
                                    class="position-relative btn btn-info stretched-link"
                                    href="${rutaVerDetalles}"
                                >
                                    Ver detalles
                                </a>
                            `;
                        }
                        return datos;
                    },
                    orderable: false,
                },
                {
                    data: null,
                    title: "Administrar",
                    render: (datos, tipo, fila, meta) => {
                        if (tipo === "display") {
                            const rutaAdministrar = this.rutaAdministrarValue.replace(/__nombre_usuario__/g, datos.nombreUsuario);
                            return html `
                                <button
                                    class="btn btn-info ${claseAdministrar}"
                                    data-ruta-administrar="${rutaAdministrar}"
                                >
                                    Administrar
                                </a>
                            `;
                        }
                        return datos;
                    },
                    orderable: false,
                },
                {
                    data: null,
                    title: "Eliminar",
                    render: (datos, tipo, fila, meta) => {
                        if (tipo === "display") {
                            const rutaEliminar = this.rutaEliminarValue.replace(/__nombre_usuario__/g, datos.nombreUsuario);
                            return html `
                                <button
                                    class="btn btn-danger ${claseEliminar}"
                                    data-compania-id="${datos.nombreUsuario}"
                                    data-ruta-eliminar="${rutaEliminar}"
                                >
                                    Eliminar
                                </button>
                            `;
                        }
                        return datos;
                    },
                    orderable: false,
                },
            ],
            responsive: true,
            fixedHeader: true,
            processing: true,
            scrollX: true,
            deferRender: true,
            serverSide: true,
            ajax: {
                url: this.rutaDatosValue,
                // TODO: manejar busqueda de fecha
            },
            search: {
                return: true,
            },
            lengthMenu: [10, 25, 50, 75, 100],
            pageLength: 25,
            createdRow: (fila, datos) => {
                const compania = datos;
                const llaveCriptograficaExpiracionFecha = new Date(Date.parse(compania.llaveCriptograficaExpiracion));
                const hoy = new Date();
                if (hoy.getTime() >= llaveCriptograficaExpiracionFecha.getTime()) {
                    fila.classList.add(this.filaProblemaClass);
                }
                else {
                    const expiracionAdelantada = new Date(llaveCriptograficaExpiracionFecha);
                    expiracionAdelantada.setUTCDate(expiracionAdelantada.getUTCDate() -
                        this.advertenciaExpiracionDiasValue);
                    if (hoy.getTime() >= expiracionAdelantada.getTime()) {
                        fila.classList.add(this.filaAdvertenciaClass);
                    }
                }
            },
        });
        const self = this;
        $(tabla)
            .on("change", `.${claseCambiarEstaActivo}`, async function () {
            const checkbox = this;
            if (!checkbox.parentElement) {
                return () => { };
            }
            const limpiar = (() => {
                loading(checkbox.parentElement, "Procesando...");
                checkbox.disabled = true;
                return () => {
                    checkbox.disabled = false;
                };
            })();
            const rutaCambiarEstaActivo = checkbox.dataset.rutaCambiarEstaActivo;
            const resultado = await window
                .fetch(rutaCambiarEstaActivo)
                .then((respuesta) => respuesta.json())
                .then((datos) => {
                if (datos.error) {
                    return { error: datos.error };
                }
                if (!("state" in datos)) {
                    return { error: "Respuesta inesperada del servidor." };
                }
                return { estaActivo: !!datos.state };
            })
                .catch((error) => ({ error }))
                .finally(limpiar);
            if ("error" in resultado) {
                Swal.fire({
                    title: "Error",
                    text: `Se presentó un problema cambiando el estado de la compañia: ${resultado.error}`,
                });
            }
            self.recargarTabla();
        })
            .on("click", `.${claseAdministrar}`, async function () {
            const boton = this;
            if (!boton.parentElement) {
                return () => { };
            }
            const limpiar = (() => {
                loading(boton.parentElement, "Procesando...");
                boton.disabled = true;
                return () => {
                    boton.disabled = false;
                };
            })();
            const rutaAdministrar = boton.dataset.rutaAdministrar;
            const resultado = await window
                .fetch(rutaAdministrar)
                .then((respuesta) => respuesta.json())
                .then((datos) => {
                if (datos.error) {
                    if (datos.msg) {
                        return { error: datos.msg };
                    }
                    return { error: "Error desconocido." };
                }
                return {};
            })
                .catch((error) => ({ error }))
                .finally(limpiar);
            if ("error" in resultado) {
                Swal.fire({
                    title: "Error",
                    text: `Se presentó un problema pasando a administrar la compañia: ${resultado.error}`,
                });
                self.recargarTabla();
            }
            else {
                Swal.fire({
                    title: "Cambiando compañia...",
                    text: "Procediendo a administración de compañia...",
                });
                window.setTimeout(() => {
                    window.location.reload();
                }, 1500);
            }
        })
            .on("click", `.${claseEliminar}`, async function () {
            const boton = this;
            if (!boton.parentElement) {
                return () => { };
            }
            const companiaId = boton.dataset.companiaId;
            const rutaEliminar = boton.dataset.rutaEliminar;
            const resultadoConfirmarEliminar = await Swal.fire({
                title: "Eliminar compañia",
                text: `¿Está seguro que desea eliminar la compañia "${companiaId}"?`,
                icon: "warning",
                showCancelButton: true,
            });
            if (!resultadoConfirmarEliminar.isConfirmed) {
                return;
            }
            const limpiar = (() => {
                loading(boton.parentElement, "Procesando...");
                boton.disabled = true;
                return () => {
                    boton.disabled = false;
                };
            })();
            const resultado = await window
                .fetch(rutaEliminar)
                .then((respuesta) => respuesta.json())
                .then((datos) => {
                if (datos.error) {
                    if (datos.msg) {
                        return { error: datos.msg };
                    }
                    return { error: "Error desconocido." };
                }
                return {};
            })
                .catch((error) => ({ error }))
                .finally(limpiar);
            if ("error" in resultado) {
                Swal.fire({
                    title: "Error",
                    text: `Se presentó un problema eliminando la compañia: ${resultado.error}`,
                });
            }
            self.recargarTabla();
        });
    }
    recargarTabla() {
        this.$dataTable.ajax.reload(undefined, false);
    }
}
default_1.values = {
    rutaDatos: String,
    rutaVerDetalles: String,
    rutaEliminar: String,
    rutaCambiarEstaActivo: String,
    rutaAdministrar: String,
    advertenciaExpiracionDias: Number,
};
default_1.classes = ["filaAdvertencia", "filaProblema"];
//# sourceMappingURL=tabla_controller.js.map